import { AggregatorReportInterface, DailyReportInterface, IncomeStatementResponse } from 'types';
import HTTPClient, { HTTPClientParameters } from './HTTPClient';
import cache from './cache';

type ReportsClientServiceParams = HTTPClientParameters;

const tenMinutesInMilliseconds = 10 * 60000;
class ReportsClient extends HTTPClient {
    constructor(params: ReportsClientServiceParams) {
        super(params);
        this.headers.set('Content-Type', 'application/json');
    }

    @cache(tenMinutesInMilliseconds)
    getIncomeStatementReport(orgUuid: string, startDate: string, endDate: string): Promise<IncomeStatementResponse> {
        const request = `reports/income_statement?organization=${orgUuid}&start_date=${startDate}&end_date=${endDate}`;
        return this.get(request);
    }

    @cache(tenMinutesInMilliseconds)
    getAggregatorReports(spotPk: number, filters: { month: string; year: string }): Promise<AggregatorReportInterface> {
        return this.get(`reports/aggregators?spot=${spotPk}&month=${filters.month}&year=${filters.year}`);
    }

    @cache(tenMinutesInMilliseconds)
    getDailyReports(spotPk: number, searchQuery: string): Promise<DailyReportInterface> {
        return this.get(`reports/daily_reports?spot=${spotPk}${searchQuery}`);
    }
}

export default ReportsClient;
